<template>
  <div
    class="btn-square border border-solid border-important-border w-6 h-6 px-0 hover:bg-important-hover bg-important-bg group"
  >
    <em
      class="custom-icons action-icon-small-card bg-icon-default group-hover:bg-icon-hover"
      :style="getCustomIconStyle(iconPath('more-horizontal'))"
    />
  </div>
</template>

<script>
import customIconsMixin from '@/mixins/customIconsMixin';

export default {
  name: 'CardActionsButton',
  mixins: [customIconsMixin],
};
</script>
